import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/image/bean_cheer.svg'


const _hoisted_1 = { class: "welcome-modal" }
const _hoisted_2 = { class: "btn-action" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["CommonModal"], {
    ref: "welcomeModal",
    "is-full-screen": false,
    "can-close": true
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { style: {"display":"flex"} }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: ""
          })
        ], -1 /* HOISTED */)),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "main-title" }, [
          _createElementVNode("h2", { class: "title" }, " Sua conta foi configurada com sucesso! "),
          _createElementVNode("p", { class: "description" }, [
            _createElementVNode("b", null, "Tudo pronto para começar!"),
            _createTextVNode(" Agora você pode aproveitar as vantagens e facilidades da sua conta Foodpass! ")
          ])
        ], -1 /* HOISTED */)),
        _createElementVNode("div", _hoisted_2, [
          _createVNode($setup["CommonButton"], {
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.welcomeModal?.close())),
            text: "Começar a usar"
          })
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 512 /* NEED_PATCH */))
}